import React from "react";
import { Link } from "react-router-dom";
import "./WhyChooseDriveIn.css";
import carDetailingImg from "../assets/Why-Choose-Drive-1.png";
import dealershipImg from "../assets/Why-Choose-Drive-2.png";
import entrepreneursImg from "../assets/Why-Choose-Drive-3.png";
import upgradeImg from "../assets/Why-Choose-Drive-4.png";
import petrolPumpImg from "../assets/Why-Choose-Drive-1.png";
import highwayImg from "../assets/Why-Choose-Drive-2.png";

const cards = [
  {
    id: "card-1",
    img: carDetailingImg,
    title: "Car detailing studios",
  },
  {
    id: "card-2",
    img: dealershipImg,
    title: "Dealership service centres",
  },
  {
    id: "card-3",
    img: entrepreneursImg,
    title: "Entrepreneurs entering auto care",
  },
  {
    id: "card-4",
    img: upgradeImg,
    title: "Existing car wash owners looking to upgrade",
  },
  {
    id: "card-5",
    img: petrolPumpImg,
    title: "Petrol Pumps and electric charging stations",
  },
  {
    id: "card-6",
    img: highwayImg,
    title: "Highway restaurants",
  },
];

const WhyChooseDriveIn = () => {
  return (
    <div className="why-drivein-section">
      <h2 className="why-drivein-title">Who Can Apply as a Channel Partner?</h2>
      <p className="text-center mb-4">You don’t need prior car wash experience, just business intent, operational discipline, and customer-first thinking.</p>

      {/* First Row - Scroll Right */}
      <div className="why-drivein-carousel-wrapper scroll-right">
        <div className="why-drivein-carousel-track">
          {[...cards, ...cards].map((card, index) => (
            <div className="why-drivein-card" key={`right-${index}`}>
              <img src={card.img} alt={card.title} />
              <h4>{card.title}</h4>
              <Link to="/contact" className="why-drivein-btn">
                Partner Us <span>↗</span>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Second Row - Scroll Left */}
      <div className="why-drivein-carousel-wrapper scroll-left">
        <div className="why-drivein-carousel-track">
          {[...cards, ...cards].map((card, index) => (
            <div className="why-drivein-card" key={`left-${index}`}>
              <img src={card.img} alt={card.title} />
              <h4>{card.title}</h4>
              <Link to="/contact" className="why-drivein-btn">
                Partner Us <span>↗</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseDriveIn;
